import style from './loader.module.css';
import React from 'react';
const Loader = () => {
    return (
        <div className={style.spinnerContainer}>
            <div className={style.spinnerWrapper}>
                <div className={style.spinner}></div>
                
            </div>
        </div>
    )
}

export default Loader;